import React from 'react';
import styled from 'styled-components';
import { Box, Flex, Relative, Absolute, getPaletteColor, Text } from 'pcln-design-system';
import { TripSummaryCard } from '@pcln/cards';
import { Clock } from 'pcln-icons';
import { HotelsOutline } from '@pcln/brand';
const IconWrapper = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "ExtendStayCard__IconWrapper",
  componentId: "sc-jy5l84-0"
})(["border:1px dashed ", ";"], props => getPaletteColor('primary.base')(props));
const ExtendStayIcon = () => React.createElement(Relative, null, React.createElement(IconWrapper, {
  p: 1,
  borderRadius: 'full',
  size: 64
}, React.createElement(Flex, {
  m: 'auto',
  borderRadius: 'full',
  bg: 'primary.light',
  px: 2,
  py: 1
}, React.createElement(Box, {
  mt: 1
}, React.createElement(HotelsOutline, {
  size: '32px',
  title: 'hotel-icon'
})))), React.createElement(Absolute, {
  bottom: 0,
  right: 0
}, React.createElement(Flex, {
  alignItems: 'center',
  justifyContent: 'center',
  color: 'text.lightest',
  bg: 'primary.light',
  height: '20px',
  width: '20px',
  borderRadius: 'full',
  boxShadow: 'sm'
}, React.createElement(Clock, {
  color: 'primary',
  size: 20
}))));
/** @public */
export default function ExtendStayCard({
  className,
  cityName,
  hoverBoxShadowSize,
  showArrowRight,
  onClick,
  handleSubmitCTA,
  headingOverride,
  captionOverride,
  disclaimerTextOverride
}) {
  return React.createElement(TripSummaryCard, {
    className: className,
    hoverBoxShadowSize: hoverBoxShadowSize,
    mediaNode: React.createElement(ExtendStayIcon, null),
    mediaNodeBackgroundColor: 'transparent',
    heading: headingOverride || `Extend Your Stay in ${cityName}`,
    caption: captionOverride || 'Extend your hotel stay & save even more with Priceline’s best available rates.*',
    body: React.createElement(Text, {
      textStyle: 'disclaimer',
      color: 'text.light'
    }, disclaimerTextOverride || '* This will be a separate reservation. Your current reservation will remain unchanged and in rare cases, the hotel may require you to move rooms.'),
    truncateHeading: true,
    showArrowRight: showArrowRight,
    onClick: onClick,
    handleSubmitCTA: handleSubmitCTA
  });
}